const compressGraphql = graphQL =>
    graphQL
        .replace(/#.*\n/g, '')
        .replace(/[\s|,]*\n+[\s|,]*/g, ' ')
        .replace(/:\s/g, ':')
        .replace(/,\s/g, ',')
        .replace(/\)\s\{/g, '){')
        .replace(/\}\s/g, '}')
        .replace(/\{\s/g, '{')
        .replace(/\s\}/g, '}')
        .replace(/\s\{/g, '{')
        .replace(/\)\s/g, ')')
        .replace(/\(\s/g, '(')
        .replace(/\s\)/g, ')')
        .replace(/\s\(/g, '(')
        .replace(/=\s/g, '=')
        .replace(/\s=/g, '=')
        .replace(/@\s/g, '@')
        .replace(/\s@/g, '@')
        .replace(/\s\$/g, '$')
        .replace(/\s\./g, '.')
        .trim();

export default compressGraphql;
